<template>
    <div>
        <el-dialog title="Update Profile" :visible.sync="selfVisible" width="40%" center>
            <el-form :model="form" label-position="left" label-width="160px">
                <el-form-item label="Name" prop="name">
                    <el-input v-model="form.name" placeholder="name"></el-input>
                </el-form-item>

                <el-form-item label="Bank" prop="bank">
                    <el-input v-model="form.bank" placeholder="Bank"></el-input>
                </el-form-item>

                <el-form-item label="Bank account" prop="bankAccount">
                    <el-input v-model="form.bankAccount" placeholder="Bank account"></el-input>
                </el-form-item>

                <el-form-item label="Mail address" prop="address">
                    <el-input v-model="form.address" placeholder="Mail address"></el-input>
                </el-form-item>

                <el-form-item label="Email" prop="email">
                    <el-input v-model="form.email" placeholder="Email"></el-input>
                </el-form-item>

                <el-form-item label="Contact" prop="contact">
                    <el-input v-model="form.contact" placeholder="contact"></el-input>
                </el-form-item>

                <el-form-item label="Postal code" prop="postalCode">
                    <el-input v-model="form.postalCode" placeholder="Postal code"></el-input>
                </el-form-item>

                <el-form-item label="IC number/UEN" prop="uen">
                    <el-input v-model="form.uen" placeholder="IC number/UEN"></el-input>
                </el-form-item>

                <el-form-item label="Mobile" prop="mobile">
                    <el-input v-model="form.mobile" placeholder="mobile"></el-input>
                </el-form-item>

                <el-form-item label="Gender" v-if="form.role !==1">
                    <el-select v-model="form.gender">
                        <el-option
                                v-for="item in [{value:1,label:'F'},{value:2,label:'M'}]"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Create Date">
                    {{form.createTime | dateFmt}}
                </el-form-item>

                <el-form-item label="Verification Documents">
                    <image-uploader :updated-files.sync="files"></image-uploader>
                </el-form-item>
            </el-form>

            <el-tree
                    ref="tree"
                    :default-checked-keys="selected"
                    :data="services"
                    node-key="id"
                    :props="{label:'name', children:'subService'}"
                    show-checkbox>
            </el-tree>

            <div slot="footer" class="dialog-footer">
                <el-button v-if=" form.status===2" type="success" @click="audit(1)">Pass
                </el-button>

                <el-button v-if=" form.status===2" type="danger" @click="audit(4)">Rework
                </el-button>

                <el-button v-if="form.role!==3" type="primary" @click="save">Save</el-button>
                <el-button @click="selfVisible = false">Cancel</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        vendor,
        vendorUpdate,
        vendorAudit,
        vendorFile,
        vendorServiceList,
    } from '@/api/VendorAPI'
    import {format} from '@/utils/Date'
    import ImageUploader from "@/components/ImageUploader";

    export default {
        name: 'CommServiceModifyDialog',
        props: {id: {required: true, type: Number}, visible: {required: true}},
        components: {ImageUploader},
        data() {
            return {
                form: {},
                files: [],
                services: [],
                selfVisible: this.selfVisible ? this.selfVisible : this.visible,
                selected: [],
            }
        },
        methods: {
            save() {
                const data = this.$copy(this.form);
                data.services = this.$refs.tree.getCheckedKeys()
                data.files = this.files
                vendorUpdate(data)
                    .then(() => {
                        this.$msg.success('Success')
                        this.selfVisible = false
                    })
            },
            audit(status) {
                vendorAudit(this.id, status)
                    .then(res => {
                        if (res.status === 200) {
                            this.$msg.success('Success')
                        }
                    })
            },
            loadData() {
                vendor(this.id)
                    .then(res => {
                        this.form = res.data
                    })
                vendorFile(this.id)
                    .then(res => {
                        const data = res.data
                        this.files = data.map(item => item.file.path)
                    })
                vendorServiceList(this.id)
                    .then(res => {
                        const data = res.data;
                        this.services = data.data
                        this.selected = data.selectedIds;
                    })
            }
        },
        mounted() {
            this.loadData()
        },
        watch: {
            'selfVisible': function (val) {
                this.$emit('update:visible', val)
            }
        },
        filters: {
            formatDate(time) {
                return format(time)
            }
        }
    }
</script>

<style scoped>

</style>
